import { IRunSessionUseCase } from '../../interfaces/use-cases/IRunSessionUseCase';
import { ISessionManager } from '../../interfaces/core/ISessionManager';
import { ISessionExecutor, ISessionExecutionResult } from '../../interfaces/core/ISessionExecutor';

export class RunSessionUseCase implements IRunSessionUseCase {
  constructor(
    private sessionManager: ISessionManager,
    private sessionExecutor: ISessionExecutor
  ) {}

  async execute(label: string): Promise<ISessionExecutionResult> {
    const session = this.sessionManager.getSession(label);
    
    if (!session) {
      throw new Error(`Session with label '${label}' not found`);
    }

    if (session.completed) {
      console.warn(`Session '${session.label}' has already been run.`);
      return {
        sessionId: session.id,
        sessionLabel: session.label,
        stats: { tests: 0, passes: 0, pending: 0, failures: 0 },
        success: true,
        duration: 0
      };
    }

    return this.sessionExecutor.execute(session);
  }
}
